import React from 'react';
import CrearObjetos from '../../../components/insumos/objetos/CrearObjetos';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Crear Clasificacion Insumos</h1>
      <br />
      <br />
      <CrearObjetos />
    </div>
  );
};

export default InsumosPage;